import { get } from 'lodash';

const errorMessages = {
  ProtocolErrorCode: {
    ZERO_INVALID_AMOUNT: 'Množství v položce skladové karty nemůže být menší než 0',
    WAREHOUSE_INVALID_AMOUNT: 'Množství inventáře skladu nemůže být menší než 0',
    EMPLOYEE_INVALID_AMOUNT: 'Počet položek v inventáři zaměstnance nemůže být menší než 0',
    RECEIPT_INVALID_AMOUNT: 'Počet přijatého zboží nemůže být vyšší než počet vydaného zboží ze stejného skladu'
  },
  WarehouseErrorCode: {
    ITEM_NOT_FOUND: 'Položka nebyla nalezena',
    ITEM_NOT_FOUND_ZERO_AMOUNT: 'Položka nebyla nalezena nebo množství nemůže být menší než 0',
    ITEM_ZERO_AMOUNT: 'Množství nemůže být menší než 0'
  },
  EventBccpCode: {
    BCCP_NOT_FOUND: 'Nahrávka nebyla nalezena na disku',
    BCCP_GET_ERROR: 'Při získávání záznamů nastala chyba na straně API',
    BCCP_PROCESS_ERROR: 'Při zpracovávání záznamů nastala chyba na straně API'
  },
  EventIsepErrorCode: {
    PARTICIPANT_NOT_FOUND: 'Účastník nebyl nalezen',
    PERSON_MISSING_AIFO: 'Opis z ISEP nelze provést, nebyla provedena lustrace ISZR!'
  },
  EventIsrtErrorCode: {
    MANUAL_PROCESSING: 'Opis nelze zpracovat automaticky, bude zaslán na e-mail',
    CANNOT_PROCESS: 'Tento požadavek není možné na straně ISRT zpracovat',
    ISRT_ERROR: 'nelze provést lustraci (chyba na straně ISRT, výpadek systému apod.)',
    PARTICIPANT_NOT_FOUND: 'Účastník nebyl nalezen v systému IQ Metropolis',
    SPECIFIC_ERRORS: 'Během lustrace nastala chyba: '
  },
  TripErrorCode: {
    CAN_NOT_SAVE: 'Jízda překrývá existující jízdu, nebo už je jízda uložena',
    TRIP_DATES_CAN_NOT_BE_NULL: 'Začátek nebo konec jízdy není definovaný'
  },
  EventLockCode: {
    LOCK_DOESNT_EXIST: 'Vypršel ochranný zámek na tuto událost'
  },
  PaymentRegisterErrorCode: {
    MULTIPLE_RESULTS: 'Registr poplatků obsahuje více osob se stejnými údaji, není možné určit plátce.',
    EXTERNAL_ERROR: 'Registr poplatků vrátil dosud neznámou chybu, kontaktujte prosím administrátora.'
  },
  PaymentValidationRegisterErrorCode: {
    INVALID_PERSON: 'Osoba plátce nemá vyplněný některý z povinných údajů (jméno, příjmení, datum narození nebo rodné číslo a obec).'
  }
};

export default (errorBody?: {
  type: string;
  code: string;
  status: number;
  message: string;
  arguments?: Record<string, any>;
}) => {
  let completeMessage;
  const {
    type,
    code,
    status,
    message,
    arguments: serverArguments = {}
  } = errorBody || {
    type: '',
    code: '',
    status: 500,
    message: '',
    arguments: {}
  };
  if (type && code) {
    completeMessage = get(errorMessages, `${type}.${code}`, 'Něco se nepovedlo');

    // Special case for EventIsrtErrorCode.SPECIFIC_ERRORS
    if (type === 'EventIsrtErrorCode' && code === 'SPECIFIC_ERRORS') {
      completeMessage += serverArguments.errors || '';
    }
  } else if (message) {
    return message;
  } else {
    switch (status) {
      case 403:
        completeMessage = 'Nemáte oprávnění';
        break;
      default:
        completeMessage = 'Něco se nepovedlo';
    }
  }
  return completeMessage;
};



// WEBPACK FOOTER //
// ./src/utils/errorMessages.ts